import * as config from "../config"
import fetch from "isomorphic-fetch"
import getJamFilledCookie from "../getJamFilledCookie"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"

export default async function validateToken(): Promise<boolean> {
	try {
		const res = await fetch(`${config.API_HOSTNAME}/api/plugin/check_token`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"jam-filled-cookie": getJamFilledCookie(),
				"jam-filled-userid": getUserIdFromLocalStorage(),
			},
		})

		if (res.status === 403) return false
		else if (res.status > 299) return false
		else return true
	} catch (e) {
		return false
	}
}
